import * as React from "react";
import { useHistory,useLocation } from "react-router-dom";
import loginServices from "../services/loginServices";
import jwt_decode from "jwt-decode";
const authContext = React.createContext();
/**
 * @component  useAuth
 * @description Provide auth to all component  for the project
 * @returns Redirected Component
 */
function useAuth() {
  let history = useHistory();
  let location = useLocation();
  const [authed, setAuthed] = React.useState(false);
  const [screenLoader, setScreenLoader] = React.useState(true);
  const [userData, setUserData] = React.useState({});
  const [bearerToken, setBearerToken] = React.useState(null);

  var localStorageData = JSON.parse(localStorage.getItem("userData"));

  // check user login from localStorage
  React.useLayoutEffect(()=>{
    if(localStorageData!==null && localStorageData!== undefined){
      setAuthed(true);
      setUserData(localStorageData);
      setBearerToken(localStorageData.authenticationToken.authToken);
      if(location.pathname === '/login') {
        history.push("/home"); 
      }  
      setScreenLoader(false)   
      checkTokenExpirationMiddleware(localStorageData)
    }else{
      setScreenLoader(false)
    }
  },[]) 

  // function call after token expire  
  const checkTokenExpirationMiddleware = (data)=> {
    const token = data.authenticationToken.authToken;
    if (jwt_decode(token).exp < Date.now() / 1000) {
      console.log('token expire')
      history.push("/login");
      setAuthed(false)
      localStorage.removeItem("userData");
    }
  };


  //function call on 401 status of api
  const unauthorizedUser=()=>{
    console.log('unauthorizedUser')
    localStorage.removeItem("userData");
    history.push("/login");
  }
  

  return {
    authed,
    localStorageData,
    userData,
    bearerToken,
    screenLoader,
    unauthorizedUser,
    // login function 
    login(formData) {
      return new Promise(async(res) => {
        let response =  await loginServices.validateUserLogin(formData);
        if (response) {
          if (response.data) {
            if(response.data.apiResponse!== null){
              setAuthed(true);
              history.push("/home");
              res(response);
              localStorage.setItem(
                "userData",
                JSON.stringify(response.data.apiResponse)
              );
            }else{
              res(response);
            }
          } else if (response.error) {
            res(response);
          }
        }
        
      });
    },
    // logout function 
    logout() {
      return new Promise((res) => {
        localStorage.removeItem("userData");
        setUserData(null)
        setAuthed(false);
        res(true);
      });
    }
  };
}


export function AuthProvider({ children }) {
    const auth = useAuth();
    return (
      <authContext.Provider value={auth}>
        {children}
      </authContext.Provider>
    );
  }
  
  export default function AuthConsumer() {
    return React.useContext(authContext);
  }
